module.exports = __webpack_public_path__ + "static/media/Step 1.92e49fe3.mp3";